module.exports = __webpack_public_path__ + "img/cmacgmLogo.de7364f5.png";